<template>
  <v-dialog
    :value="value"
    :persistent="loading"
    width="400"
    @input="$emit('input', $event)"
  >
    <v-card :disabled="loading" :loading="loading">
      <v-form
        v-model="validForm"
        :disabled="loading"
        @submit.prevent="submitChanges"
      >
        <v-card-title>Edit child name</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="formData.firstName"
            :rules="rules.firstName"
            label="First name"
            outlined
          />
          <v-text-field
            v-model="formData.lastName"
            :rules="rules.lastName"
            label="Last name"
            outlined
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            text
            @click="close"
          >
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!validForm || isInitialFormState"
            type="submit"
            color="blue"
            class="white--text"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isEqual, cloneDeep } from 'lodash';

const nameRegex = /\b([A-ZÀ-ÿ][-,a-z. ']+[ ]*)+/;
const nameRules = [
  v => !!v || 'Field is required',
  v => v?.length <= 50 || 'Max length is 50',
  v => nameRegex.test(v) || 'Invalid name format',
];

export default {
  name: 'EditChildNameDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      validForm: false,
      formData: {
        firstName: '',
        lastName: '',
      },
      initialFormData: null,
      rules: {
        firstName: nameRules,
        lastName: nameRules,
      },
    };
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    isInitialFormState() {
      return isEqual(this.formData, this.initialFormData);
    },
  },
  created() {
    this.initFormData();
  },
  methods: {
    ...mapActions('children', [
      'updateActiveChild',
    ]),
    submitChanges() {
      if (this.loading || !this.validForm) return;

      this.loading = true;
      this.updateActiveChild({
        first_name: this.formData.firstName,
        last_name: this.formData.lastName,
      })
        .then(() => {
          this.$toast.success('Name successfully updated');
          this.initFormData();
        })
        .catch(() => this.$toast.error('Failed to update name'))
        .finally(() => (this.loading = false));
    },
    close() {
      this.$emit('input', false);
    },
    initFormData() {
      this.formData.firstName = this.activeChildProfile.first_name;
      this.formData.lastName = this.activeChildProfile.last_name;
      this.initialFormData = cloneDeep(this.formData);
    },
  },
};
</script>
